<template>
  <div class="top5-list">
    <h3
      v-if="showTitle"
      class="top5-list__title"
    >
      {{ title }}
    </h3>
    <BiChartEmpty v-if="!loading && !hasData" />
    <template v-else>
      <div class="top5-list__table">
        <div class="top5-list__header">
          <span
            v-for="column in columns"
            :key="column.key"
            :style="{ flex: columnFlex(column), textAlign: column.align || 'left' }"
          >
            {{ column.title }}
          </span>
        </div>
        <div
          v-for="(item, index) in topItems"
          :key="index"
          class="top5-list__row"
          :style="{
            marginBottom:
              index === topItems.length - 1 ? `${lastRowMargin}px` : undefined,
          }"
        >
          <span
            v-for="column in columns"
            :key="column.key"
            :class="{ 'top5-list__total': column.align === 'right' }"
            :style="{ flex: columnFlex(column), textAlign: column.align || 'left' }"
          >
            {{ column.indexPrefix ? `${index + 1}. ` : '' }}{{ item[column.key] }}
            <span
              v-if="column.deltaKey"
              class="top5-list__badge"
              :class="`top5-list__badge--${item[column.deltaVariantKey]}`"
            >
              {{ item[column.deltaKey] }}
            </span>
          </span>
        </div>
      </div>
      <slot name="footer" />
    </template>
  </div>
</template>

<script>
import BiChartEmpty from './BiChartEmpty.vue'
import { hasChartData } from './chartData'

export default {
  name: 'Top5List',
  components: { BiChartEmpty },
  props: {
    data: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    title: { type: String, default: 'Top 5' },
    showTitle: { type: Boolean, default: true },
    lastRowMargin: { type: Number, default: 15 },
    limit: { type: Number, default: 5 },
    sortKey: { type: String, default: 'value' },
    valueKey: { type: String, default: '' },
    columns: {
      type: Array,
      default: () => [
        { key: 'name', title: 'Motivo', indexPrefix: true },
        { key: 'value', title: 'Total', align: 'right' },
      ],
    },
  },
  computed: {
    hasData() {
      return hasChartData(this.data, this.valueKey || this.sortKey)
    },
    topItems() {
      return [...this.data]
        .sort((a, b) => b[this.sortKey] - a[this.sortKey])
        .slice(0, this.limit)
    },
  },
  methods: {
    columnFlex(column) {
      if (column.flex !== undefined) return column.flex
      return column.align === 'right' ? 0 : 1
    },
  },
}
</script>

<style scoped lang="scss">
.top5-list {
  display: flex;
  flex-direction: column;
  font-family: 'Roboto', sans-serif;

  &__title {
    margin: 0 0 12px;
    color: rgba(70, 70, 70, 1);
    font-size: 16px;
    font-weight: 700;
  }

  &__table {
    width: 100%;
  }

  &__header {
    display: flex;
    padding-bottom: 8px;
    margin-bottom: 4px;
    color: rgba(90, 90, 90, 1);
    font-size: 14px;
  }

  &__row {
    display: flex;
    align-items: center;
    padding: 16px 0;
    border-bottom: 1px solid rgba(230, 230, 230, 1);
    color: #444;
    font-size: 14px;
    transition: background-color 120ms ease;

    &:hover {
      background-color: #f2f2f2;
    }
  }

  &__total {
    flex-shrink: 0;
    color: #333;
  }

  &__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    padding: 0 8px;
    height: 21px;
    min-width: 43px;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;

    &--green {
      background: rgba(34, 114, 58, 1);
    }

    &--red {
      background: rgba(218, 51, 71, 1);
    }
  }
}
</style>
